export default class UtilAxiosDownload {
  constructor() {
    this.config = {
      withCredentials: false,
      crossdomain: true,
      responseType: "blob"
    }
  }
}
